import { Link, ButtonBase } from '@stitch-fix/mode-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { SignInFormWrapper } from './SignInFormWrapper';
import { type EmailSchema, emailSchema } from '../../utils/zod/emailSchema';
import { requestPasswordlessLogin } from '../../utils/requests/clientAuth/login';
import { ControlledTextField } from '../Forms';
import { SignInFormFooter } from './SignInFormFooter';
import { SuccessScreen } from './SuccessScreen';
import { BannerWrapper } from './BannerWrapper';
import { SignInMachineContext } from '../../machines/sign-in/SignInMachineContext';

export const OneTimePasswordForm = () => {
  const [state, send] = SignInMachineContext.useActor();
  const { control, handleSubmit, getValues } = useForm<EmailSchema>({
    resolver: zodResolver(emailSchema),
    defaultValues: {},
  });

  const onSubmit = async (data: EmailSchema) => {
    try {
      await requestPasswordlessLogin(data.email);

      send({ type: 'GET_LINK_SUCCESS' });
    } catch (error) {
      send({ type: 'GET_LINK_FAILURE', error });
    }
  };

  return (
    <>
      <BannerWrapper />
      {state.matches({ passwordlessSignIn: 'linkSentSuccess' }) && (
        <SuccessScreen
          email={getValues().email}
          onResendEmailClick={() => {
            onSubmit({ email: getValues().email });
          }}
          onBackToSignInOptionsClick={() => {
            send({ type: 'EMAIL_PASSWORD_SIGNIN' });
          }}
        />
      )}

      {state.matches({ passwordlessSignIn: 'idle' }) && (
        <SignInFormWrapper
          onSubmit={handleSubmit(onSubmit)}
          subheading={
            <>
              We&apos;ll email you a link to sign in without a password.
              <br />
              You can also{' '}
              <Link
                as={ButtonBase}
                onClick={() => {
                  send('EMAIL_PASSWORD_SIGNIN');
                }}
              >
                sign in manually.
              </Link>
            </>
          }
          ctaText="Send Link"
          footer={<SignInFormFooter />}
        >
          <ControlledTextField
            control={control}
            autocomplete="username"
            name="email"
            label="Email"
          />
        </SignInFormWrapper>
      )}
    </>
  );
};
